import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import WfFormInput from './wf-form-input';
import _ from 'lodash';
import MapPic from '../../../cube-map/MapPic';

@observer
export default class InputElement extends React.Component<ExcelTableCellProps, any> {
    render() {
        const { cell, form, card, className,excel} = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const fieldName = getDomIdByFieldKey(bindObj.path);
        const bind = bindObj.bind();
        const { viewAttr: _viewAttr, isEdit, isMandatory } = bind;
        const { fieldtype, fielddbtype, isdetail, qfws, valueFormat, transtype,real_fieldtype,showhtml} = card.getFieldProps(path);
        const {isfrontmultlang = "0",quickEditStore,getDetailFormValues} = card;
        const mapAttr = card.mapStore.getMapAttr(path);

        if (mapAttr && mapAttr.caltype == '5' && mapAttr.mapdistype && mapAttr.mapdistype.indexOf('S') >= 0) {
            return (
                <div style={{ minHeight: 200 }}>
                    <MapPic address={bind.value} />
                    <input  {...bind} id={fieldName} type="hidden" />
                </div>
            )
        }

        const { financial, format: cellFormat } = cell;
        let viewAttr =  _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if(excel.detailProps&&excel.detailProps.hasOwnProperty("isEdit")&&card.params.type == '2'){
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if(getDetailFormValues(form).dtl_id&&!excel.detailProps["isEdit"]){
                viewAttr = 1;
            }
        }
            let format = {};
        if(financial && financial.indexOf("2-") > -1){
            const finaNum = parseInt(financial.split("-")[1] || "3");
            format = { decimals: "-1", formatPattern: "2", numberType: 100, finaNum: finaNum};
        }else if (financial == "3") {//表单布局格式下拉框中设置的单元格格式  金额大写
            format = { decimals: "-1", formatPattern: "2", numberType: 101, thousands: "-1" };
        } else if (financial == "4") {
            format = { numberType: "2", decimals: qfws + "", formatPattern: "2", thousands: "1" };
        } else {
            if (cellFormat) {
                format = cellFormat;
            } else {
                if (valueFormat) {
                    format = valueFormat;
                } else if (transtype == '1') {
                    format = { decimals: "-1", formatPattern: "2", numberType: "8", thousands: "-1" };
                } else if (transtype == '2') {
                    format = { numberType: "2", decimals: qfws + "", formatPattern: "2", thousands: "1" };
                } else { ////字段原有单元格格式
                    if (fieldtype == '3') {
                        format = { numberType: "2", decimals: qfws + "", formatPattern: "2", thousands: "0" };//浮点数
                    } else if (fieldtype == '4' || fieldtype == '5') {
                        format = { numberType: "2", decimals: qfws + "", formatPattern: "2", thousands: "1" };//金额转换
                    }
                }
            }
        }

        let fieldlength_tmp: number; //fieldtype 1文本   2整数(11)   4金额转换   3浮点(38)
        if (fieldtype == '1') {
            fieldlength_tmp = parseInt(fielddbtype.substring(fielddbtype.indexOf("(") + 1, fielddbtype.length - 1));
        } else if (fieldtype == '2') {
            fieldlength_tmp = 11;
        } else {
            fieldlength_tmp = 38;
        }
        let placeholder = bind.placeholder;
        if(card.detailMap[`${fieldName}`]&&card.detailMap[`${fieldName}`]['emptyShowContent']){
            placeholder = card.detailMap[`${fieldName}`]['emptyShowContent'];
        }
        const showMapIcon = mapAttr && mapAttr.caltype == '5' && (!mapAttr.mapdistype || mapAttr.mapdistype.indexOf('S') < 0);
        const component = <WfFormInput
            wrapStyle={isdetail ? { width: `${showMapIcon ? 'calc( 100% - 20px )' : '90%'}`, height: 28 } : { width: '89%', height: 28 }}
            fieldName={fieldName}
            format={format}
            value={bind.value}
            viewAttr={viewAttr}
            placeholder={placeholder}
            fieldid={fieldName}
            detailtype={fieldtype}
            qfws={qfws}
            length={fieldlength_tmp}
            fieldlabel={bind.label}
            onChange={this.inputChange}
            onFocus={bind.onFocus()}
			onBlur={bind.onBlur()}
            isDetail={isdetail}
            isfrontmultlang ={isfrontmultlang}
            cell={cell}
            real_fieldtype={real_fieldtype}
            showhtml={showhtml}
        />
        const canQuickedit = bindObj.isquickedit && viewAttr == '1';
        return (
            <div className={`${canQuickedit ? 'cube-card-editformitem ':'cube-card-editformitem2'} fieldValue ${className}`} 
            data-fieldattr={viewAttr} data-fieldmark={fieldName} {...cell.cellProps} 
            onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                {component}
                {showMapIcon && <i className="icon-coms-position" style={{ marginLeft: 5 }} onClick={this.handleMap.bind(this, bind.value, path, form)} />}
                <span className="editicon"><i className="icon-coms-edit" ></i></span>
            </div>
        )
    }

    inputChange= (v, change = false) => {
        const { cell, form, card} = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const bind = bindObj.bind();
        const { fieldtype} = card.getFieldProps(path);
        if (!_.isEqual(v, bind.value) || change) {
            // 金额千分位和浮点数值相等时不更新
            if (fieldtype === '5' && _.isEqual(v, bind.value.replace(/,/g, ''))) {
                return;
            }
            bind.onChange(v);
        }
    }


    /**
    * 解析外部传进来的样式
    */
    getFieldStyle = (isdetail: boolean, fieldtype: string, cellStyle: React.CSSProperties) => {
        let returnObj = {} as React.CSSProperties;
        returnObj.width = (isdetail || (fieldtype == "1" || fieldtype == "4")) ? "89%" : "54%";
        if (isdetail && fieldtype == "3")
            returnObj.width = "75%";
        if (cellStyle.verticalAlign) returnObj.verticalAlign = cellStyle.verticalAlign;
        if (cellStyle.fontSize) returnObj.fontSize = cellStyle.fontSize;
        return returnObj;
    }
    handleMap = (value, path, form) => {
        if(window['getLnglat']){
            const fieldName = getDomIdByFieldKey(form.$(path).path);
            let index = "";
            if(fieldName.indexOf("_")>-1){//明细表
                index = fieldName.substring(fieldName.indexOf("_")+1);
            }
            window['getLnglat'](path,form,index);
        }
        
        this.props.card.mapStore.onShow(value, path, form);
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/input-element/index.tsx